export default __webpack_public_path__ + "static/media/chatEmpty@2x.7c7917ed.png";